import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BootstrapModal from 'react-bootstrap/lib/Modal';
import classNames from 'classnames';

import * as styles from './styles.css';
import LoadingScreen from '../../LoadingScreen/LoadingScreen';

const COMPONENT_REF_KEY = 'componentRef';

export default class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      [COMPONENT_REF_KEY]: null,
    };
  }

  handleHide = () =>
    (this.props.rootClose ? this.props.setShow(false) : undefined);


  handleRef =
    key =>
      ref =>
        this.setState({ [key]: ref });

  handleComponentRef = this.handleRef(COMPONENT_REF_KEY);

  render() {
    return (
      <div className={classNames(styles.container, this.props.modalClassName)}>
        <BootstrapModal
          show={this.props.show}
          onHide={this.handleHide}
          bsSize={this.props.size === 'medium' ? undefined : this.props.size}
          dialogClassName={this.props.className}
        >
          <LoadingScreen isLoading={this.props.isLoading} />
          <BootstrapModal.Header closeButton={this.props.closable}>
            <BootstrapModal.Title>
              {this.props.title}
            </BootstrapModal.Title>
          </BootstrapModal.Header>
          <BootstrapModal.Body className>
            {this.props.children}
          </BootstrapModal.Body>
          <BootstrapModal.Footer>
            {this.props.footer}
          </BootstrapModal.Footer>
        </BootstrapModal>
        {this.props.component ? React.cloneElement(
          this.props.component,
          {
            handleRef: this.handleComponentRef,
            onClick: () => this.props.setShow(!this.props.show),
          },
        ) : undefined}
      </div>
    );
  }
}

Modal.defaultProps = {
  component: undefined,
  className: '',
  modalClassName: undefined,
  closable: true,
  footer: undefined,
  rootClose: true,
  show: false,
  isLoading: false,
  size: 'large',
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  modalClassName: PropTypes.string,
  closable: PropTypes.bool,
  component: PropTypes.element,
  footer: PropTypes.element,
  rootClose: PropTypes.bool,
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};
